export const DIAGNOSES_FORM = "7080437";

export const DIAGNOSES_FIELDS = Object.freeze({
  DX_OPT_1: "193341587",
  TBI_DX_CHECKBOX: "193353152",
  TBI_DETAILED_DX: "193341588",
  TBI_FURTHER_DX: "193341589",
  CT_SPINAL_DX_1: "193341601",
  CT_SPINAL_DX_1_SPEX: "193353169",
  CT_SPINAL_DX_2: "193341653",
  CT_SPINAL_DX_2_SPEX: "193353169",
  CT_SPINAL_DX_3_CHECKBOX: "193353175",
  CT_SPINAL_DX_3: "193353140",
  CT_SPINAL_DX_3_SPEX: "193353141",
  LS_SPINAL_DX_1: "193353153",
  LS_SPINAL_DX_1_SPEX: "193353154",
  LS_SPINAL_DX_2: "193353173",
  LS_SPINAL_DX_2_SPEX: "193353174",
  LS_SPINAL_DX_3_CHECKBOX: "193353175",
  LS_SPINAL_DX_3: "193353176",
  LS_SPINAL_DX_3_SPEX: "193353177",
  UE_DX_1: "193353179",
  UE_DX_1_SPEX: "193353180",
  UE_DX_2_CHECKBOX: "193353446",
  UE_DX_2: "193353447",
  UE_DX_2_SPEX: "193353448",
  LE_DX_1: "193353449",
  LE_DX_1_SPEX: "193353450",
  LE_DX_2_CHECKBOX: "193353716",
  LE_DX_2: "193353717",
  LE_DX_2_SPEX: "193353718",
  FUNCTIONAL_DX_1: "193353720",
  FUNCTIONAL_DX_1_SPEX: "193353721",
  FUNCTIONAL_DX_2_CHECKBOX: "193353988",
  FUNCTIONAL_DX_2: "193353989",
  FUNCTIONAL_DX_2_SPEX: "193353990",
  DX_OPT_2: "193354256",
} as const);

export type DiagnosesFields = keyof typeof DIAGNOSES_FIELDS;

export const DIAGNOSES_FIELD_SET = new Set(
  (Object.keys(DIAGNOSES_FIELDS) as DiagnosesFields[]).map(
    (key: DiagnosesFields) => DIAGNOSES_FIELDS[key]
  )
);

export const DIAGNOSES_REQUIRED_FIELDS = [];
